import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {isFacebook, isInstagram} from "../../misc/browsers";
import {baseNewImagesPath} from "../assets";
import MobileRotateButtonIcon from "./mobileRotateButtonIcon";
import {AmericanStandardIcon, groheIcon} from "../common/icons";

// const faceBookOldView = (isRebath) => (
//   <div className={"bv-mobile-rotate-button bv-mobile-rotate-button-fb"
//   + (isRebath ? " bv-mobile-rotate-button-fb--rebath" : "")}>
//     <div className="bv-mobile-rotate-button-fb-header">
//       Click HERE to open this tool in another browser
//     </div>
//     <div className="bv-mobile-rotate-button-fb-text">
//       Facebook doesn’t support this visualizer in the Facebook app.
//     </div>
//     <div className="bv-mobile-rotate-button-fb-logo">
//       <img src={imagePath} alt=""/>
//     </div>
//     <div className="bv-mobile-rotate-button-fb-footer">
//       <p>OR</p>
//       <p>Copy the following link into your browser:</p>
//       <p>{window.location.href.split(window.location.search)[0]}</p>
//     </div>
//   </div>
// );

class MobileRotateButton extends Component {

  getIcon = () => {
    if (this.props.fabricatorData.isAmericanStandard) {
      return AmericanStandardIcon
    }
    return groheIcon
  }

  getLogo = () => {
    switch (true) {
      case this.props.fabricatorData.isRebath:
        return `${baseNewImagesPath}images/Logos/rebath-logo.svg`
      case this.props.fabricatorData.isRona:
        return `https://qc-cdn.s3.amazonaws.com/Logos/rona.png`
      case this.props.fabricatorData.isRenoDepot:
        return `https://qc-cdn.s3.amazonaws.com/Logos/reno-depot.png`
      case this.props.fabricatorData.isLowes:
        return `${baseNewImagesPath}images/Logos/Lowes-Color-Logo.svg`
      case this.props.fabricatorData.isCaesarStone:
        return `${baseNewImagesPath}images/Logos/csconnect2.png`
      default:
        // return `${baseNewImagesPath}images/Logos/quote-logo-stacked.svg`
        return `${baseNewImagesPath}images/Logos/Quote-Kitchen-and-Bath.svg`
    }
  };

  render() {

    const {isRebath, isLowes, isRona, isRenoDepot, isAmericanStandard, isLixil} = this.props.fabricatorData;

    return isFacebook || isInstagram
      ? null : (
        <div className="bv-mobile-rotate-button">
          <div className={"bv-mobile-rotate-button-logo" + (isLowes ? " bv-mobile-rotate-button-logo--lowes" : "")
            + (isLixil ? isAmericanStandard ? " bv-mobile-rotate-button-logo--as" : " bv-mobile-rotate-button-logo--grohe" : "")}>
            {isLixil ? this.getIcon() : <img alt="" src={this.getLogo()}/>}
          </div>
          <MobileRotateButtonIcon isRebath={isRebath} isLowes={isLowes} isRona={isRona} isRenoDepot={isRenoDepot}/>
          <p className={"bv-mobile-rotate-button-text"
          + (isRebath ? " bv-mobile-rotate-button-text--rebath" : "")
          + (isRona ? " bv-mobile-rotate-button-text--rona" : "")
          + (isRenoDepot ? " bv-mobile-rotate-button-text--reno_depot" : "")
          + (isLowes ? " bv-mobile-rotate-button-text--lowes" : "")}>
            <FormattedMessage id="mobileRotateText"/>
          </p>
        </div>
      );
  }
}

const mapStateToProps = (store) => ({
  fabricatorData: store.fabricatorState
});
export default connect(mapStateToProps)(MobileRotateButton);
